import axios, { AxiosResponse } from 'axios';
import { ILeiCheckResp, IZalozeniLeiInput } from 'types/leiTypes';

const checkIcApi = (data: IZalozeniLeiInput) => {
    return axios({
        method: 'POST',
        url: '/LEI/CheckIC',
        data: data
    }).then((resp: AxiosResponse<ILeiCheckResp>) => resp.data);
};

export default checkIcApi;
